//
// AUTH CHECKS
//

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const LOGIN_REGEX = /^(?=.*[A-Za-z0-9]$)[A-Za-z][A-Za-z\d.-]{2,19}$/

export const PASS_REGEX = /^(?=.*?[a-z])(?=.*?\d).{5,}$/
export const NEW_PASS_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d).{8,}$/

export const OTP_KEY_REGEX = /^(?:\d{6}|[A-Za-z0-9_-]{8})$/
